/** Bottom-tier location (room) — must match reparent rules (level stays 5 when shifting subtree). */
export const ROOM_LOCATION_LEVEL = 5;
export const VERTICAL_LOCATION_LEVEL = 4;

export function isRoomLocationLevel(level: number | string | null | undefined): boolean {
  return Number(level) === ROOM_LOCATION_LEVEL;
}

export function isVerticalLocationLevel(level: number | string | null | undefined): boolean {
  return Number(level) === VERTICAL_LOCATION_LEVEL;
}

export const renderTitle = (level: number) => {
  let info;
  switch (level) {
    case 1:
      info = {
        title: 'Main Location',
        textButton: 'Add Main Location',
        level: 1
      };
      break;
    case 2:
      info = {
        title: 'Sub Location 1',
        textButton: 'Add Sub Location 1',
        level: 2
      };
      break;
    case 3:
      info = {
        title: 'Sub Location 2',
        textButton: 'Add Sub Location 2',
        level: 3
      };
      break;
    case 4:
      info = {
        title: 'Vertical Level',
        textButton: 'Add Vertical Level',
        level: 4
      };
      break;
    case 5:
      info = {
        title: 'Location',
        textButton: 'Add Location',
        level: 5
      };
      break;
    default:
      info = {
        title: 'Main Location',
        textButton: 'Add Main Location',
        level: 1
      };
  }
  return info;
};
